import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../../firebase/config";
import { FaUsers } from "react-icons/fa";

import {
  FaTachometerAlt,
  FaBuilding,
  FaMoneyCheckAlt,
  FaChartLine,
  FaClock,
  FaSignOutAlt,
  FaBars,
  FaTimes,
} from "react-icons/fa";

import logo from "../../assets/images/sidebaradminlogo.png";

import "./AdminSidebar.css";

export default function AdminSidebar() {
  const navigate = useNavigate();

  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/");
    } catch (error) {
      alert("Logout Failed");
    }
  };

  return (
    <>
      <button className="mobile-menu-btn" onClick={() => setSidebarOpen(true)}>
        <FaBars />
      </button>

      {sidebarOpen && (
        <div
          className="sidebar-overlay"
          onClick={() => setSidebarOpen(false)}
        ></div>
      )}

      <aside className={`admin-sidebar ${sidebarOpen ? "open" : ""}`}>
        <button className="close-sidebar" onClick={() => setSidebarOpen(false)}>
          <FaTimes />
        </button>

        <div className="sidebar-header">
          <div className="sidebar-brand">
            <img src={logo} alt="NN AI Solutions" className="brand-logo" />

            <h2>NN AI Solutions</h2>

            {/* <p>Powered Platform</p> */}
          </div>
        </div>

        <nav className="admin-menu">
          <NavLink to="/admin" end>
            <FaTachometerAlt />
            <span>Dashboard</span>
          </NavLink>

          <NavLink to="/admin/gyms">
            <FaBuilding />
            <span>Manage Gyms</span>
          </NavLink>

          <NavLink to="/admin/subscriptions">
            <FaMoneyCheckAlt />
            <span>Subscriptions</span>
          </NavLink>

          <NavLink to="/admin/revenue">
            <FaChartLine />
            <span>Revenue</span>
          </NavLink>

          <NavLink to="/admin/expiry">
            <FaClock />
            <span>Expiry Monitor</span>
          </NavLink>
          <NavLink to="/admin/leads">
            <FaUsers />
            <span>Leads</span>
          </NavLink>
        </nav>

        <button className="logout-btn" onClick={handleLogout}>
          <FaSignOutAlt />
          Logout
        </button>
      </aside>
    </>
  );
}
